import React, { useEffect, useRef, useState } from 'react';
import { Button, Checkbox, Col, DatePicker, Input, List, Row } from 'antd';
import { withRouter } from 'react-router-dom';
import './SearchBar.css';
import MultiselectExtension from '../MultiselectExtension';
import Collapse from 'react-bootstrap/Collapse';
import Container from 'react-bootstrap/Container';
import moment from 'moment';
import { CloseCircleFilled, MinusCircleOutlined, PlusCircleOutlined, SearchOutlined } from '@ant-design/icons';
import { Form } from "react-bootstrap";
import { isExternalContributorOrExternalView } from "../../utils/UserInfo";
import { projectStatusMap } from "../ProjectStatusMap";
import Cookies from 'js-cookie';

export default withRouter(function SearchBar(props) {
    const { searchProject, stations, pcAreas, stationAreas, stationRegions, bpIds, workOrders, mpIds, onClearSearch, userProfile, activeTabKey, setActiveTabKey, match } = props;
    const [suggestions, setSuggestions] = useState([]);
    const [workOrderText, setWorkOrderText] = useState("");
    const [text, setText] = useState("");
    const [bpIdText, setbpIdText] = useState("");
    const [bpIdSuggestions, setbpIdSuggestions] = useState([]);
    const [workOrderSuggestions, setWorkOrderSuggestions] = useState([]);
    const [mpIdText, setmpIdText] = useState("");
    const [mpIdSuggestions, setmpIdSuggestions] = useState([]);
    const [open, setOpen] = useState(false);
    const [myProjectsFlag, setMyProjectsFlag] = useState('');
    const userSelectionsFromCookie = Cookies.get('filters');
    const parsedUserSelectionsFrmCookie = userSelectionsFromCookie && JSON.parse(userSelectionsFromCookie);

    const activeTabValueFromContext =  props.location && props.location.state && props.location.state.activeTabKey;

    useEffect(() => {
        setMyProjectsFlag(parsedUserSelectionsFrmCookie && parsedUserSelectionsFrmCookie.selectedProjFlag ? parsedUserSelectionsFrmCookie.selectedProjFlag : '');
        searchProject.setMyProjectsFlag((parsedUserSelectionsFrmCookie && parsedUserSelectionsFrmCookie.selectedProjFlag) ? parsedUserSelectionsFrmCookie.selectedProjFlag : '');
        searchProject.selectedStationRegions = (parsedUserSelectionsFrmCookie && parsedUserSelectionsFrmCookie.selectedStatRegs) ? parsedUserSelectionsFrmCookie.selectedStatRegs : [];
        searchProject.selectedStationAreas = (parsedUserSelectionsFrmCookie && parsedUserSelectionsFrmCookie.myTFSStationAreas) ? parsedUserSelectionsFrmCookie.selectedStatAreas : [];
        searchProject.selectedPCAreas = (parsedUserSelectionsFrmCookie && parsedUserSelectionsFrmCookie.myTFSPCAreas) ? parsedUserSelectionsFrmCookie.selectedPCAreas : [];
        setActiveTabKey(((parsedUserSelectionsFrmCookie && parsedUserSelectionsFrmCookie.selectedDefaultDashView) ? projectStatusMap[parsedUserSelectionsFrmCookie.selectedDefaultDashView] :
            ((parsedUserSelectionsFrmCookie && !parsedUserSelectionsFrmCookie.selectedDefaultDashView) ? 'all' : 'upcoming')));

        
            //advance search filters default setup
            if(parsedUserSelectionsFrmCookie) {
                setText(parsedUserSelectionsFrmCookie.stationName)
                setbpIdText(parsedUserSelectionsFrmCookie.bpid)
                setmpIdText(parsedUserSelectionsFrmCookie.mpid)
                setWorkOrderText(parsedUserSelectionsFrmCookie.workOrder)

                searchProject.selectedStation(parsedUserSelectionsFrmCookie.stationName)
                searchProject.selectedBPID(parsedUserSelectionsFrmCookie.bpid)
                searchProject.selectedMPID(parsedUserSelectionsFrmCookie.mpid)
                searchProject.selectedWorkOrder(parsedUserSelectionsFrmCookie.workOrder)
                if (parsedUserSelectionsFrmCookie.constructionStartDate) {
                    searchProject.onChangeConstructionStartDate(moment(parsedUserSelectionsFrmCookie.constructionStartDate, 'MMMM DD, YYYY'));
                }
                if (parsedUserSelectionsFrmCookie.constructionEndDate) {
                    searchProject.onChangeConstructionEndDate(moment(parsedUserSelectionsFrmCookie.constructionEndDate, 'MMMM DD, YYYY'));
                }
                if (parsedUserSelectionsFrmCookie.inServiceStartDate) {
                    searchProject.onChangeInServiceStartDate(moment(parsedUserSelectionsFrmCookie.inServiceStartDate, 'MMMM DD, YYYY'));
                }
                if (parsedUserSelectionsFrmCookie.inServiceEndDate) {
                    searchProject.onChangeInServiceEndDate(moment(parsedUserSelectionsFrmCookie.inServiceEndDate, 'MMMM DD, YYYY'));
                }
                if (parsedUserSelectionsFrmCookie.commisioningStartDate) {
                    searchProject.onChangeCommisioningStartDate(moment(parsedUserSelectionsFrmCookie.commisioningStartDate, 'MMMM DD, YYYY'));
                }
                if (parsedUserSelectionsFrmCookie.commisioningEndDate) {
                    searchProject.onChangeCommisioningEndDate(moment(parsedUserSelectionsFrmCookie.commisioningEndDate, 'MMMM DD, YYYY'));
                }
                if (parsedUserSelectionsFrmCookie.expectedCloseStartDate) {
                    searchProject.onChangeExpectedCloseStartDate(moment(parsedUserSelectionsFrmCookie.expectedCloseStartDate, 'MMMM DD, YYYY'));
                }
                if (parsedUserSelectionsFrmCookie.expectedCloseEndDate) {
                    searchProject.onChangeExpectedCloseEndDate(moment(parsedUserSelectionsFrmCookie.expectedCloseEndDate, 'MMMM DD, YYYY'));
                }

                if(parsedUserSelectionsFrmCookie.constructionDateNull){
                    searchProject.setNullConstructionDate();
                }
                if(parsedUserSelectionsFrmCookie.inServiceDateNull){
                    searchProject.setNullInServiceDate();
                }
                if(parsedUserSelectionsFrmCookie.commisioningDateNull){
                    searchProject.setNullCommisioningDate();
                }
                if(parsedUserSelectionsFrmCookie.expectedDateNull){
                    searchProject.setNullExpectedDate();
                }
            }       
    }, []);

    function setAdvancedFiltersToCookie(){
            const existingFilters = JSON.parse(Cookies.get('filters'))
            Cookies.set('filters', {
                ...existingFilters,
                stationName: searchProject.stationName ? searchProject.stationName : '',
                bpid: searchProject.bpid ? searchProject.bpid : '',
                mpid: searchProject.mpid ? searchProject.mpid : '',
                workOrder: searchProject.workOrder ? searchProject.workOrder : '',
                constructionEndDate: searchProject.constructionEndDate ? searchProject.constructionEndDate : '',
                constructionStartDate: searchProject.constructionStartDate ? searchProject.constructionStartDate : '',
                inServiceStartDate:searchProject.inServiceStartDate? searchProject.inServiceStartDate: '',
                inServiceEndDate:searchProject.inServiceEndDate? searchProject.inServiceEndDate: '',
                commisioningStartDate: searchProject.commisioningStartDate ? searchProject.commisioningStartDate : '',
                commisioningEndDate: searchProject.commisioningEndDate ? searchProject.commisioningEndDate : '',
                expectedCloseStartDate:searchProject.expectedCloseStartDate ? searchProject.expectedCloseStartDate: '',
                expectedCloseEndDate:searchProject.expectedCloseEndDate? searchProject.expectedCloseEndDate: '',
                constructionDateNull: searchProject.constructionDateNull,
                inServiceDateNull: searchProject.inServiceDateNull,
                commisioningDateNull: searchProject.commisioningDateNull,
                expectedDateNull: searchProject.expectedDateNull
            });
    }

    function toggleOpen() {
        setOpen(!open);
    }

    function onTextChanged(e) {
        let value = e.target.value;
        if (!value) {
            clearStationSearch();
        }
        let suggests = [];
        if (value.length > 0) {
            value = value.replace(/[^\w\s]/gi, '');
            const regex = new RegExp(`^${value}`, "i");
            suggests = stations
                .sort()
                .filter(station => regex.test(station));
        }
        setSuggestions(suggests);
        setText(value);
    }

    async function suggestionSelected(suggestion) {
        setText(suggestion);
        setSuggestions([]);
        searchProject.selectedStation(suggestion)
        setAdvancedFiltersToCookie();
    }

    function onClear() {
        onClearSearch();
        setAdvancedFiltersToCookie();
    }

    function clearSearch() {
        clearStationSearch();
        clearBPIdSearch();
        clearWorkOrderSearch();
        clearMPIdSearch();
        clearConstructionStartDateSearch();
        clearConstructionEndDateSearch();
        clearInServiceStartDateSearch();
        clearInServiceEndDateSearch();
        clearCommisioningStartDateSearch();
        clearCommisioningEndDateSearch();
        clearExpectedCloseStartDateSearch();
        clearExpectedCloseEndDateSearch();
        clearConstructionDateNull();
        clearInServiceDateNull();
        clearCommisioningDateNull();
        clearExpectedDateNull();
        onClear();
    }

    function clearStationSearch() {
        setText("");
        searchProject.stationName = "";
        onClear();
    }

    function clearBPIdSearch() {
        setbpIdText("");
        searchProject.bpid = "";
        onClear();
    }

    function clearWorkOrderSearch() {
        setWorkOrderText("");
        searchProject.workOrder = "";
        onClear();
    }

    function clearMPIdSearch() {
        setmpIdText("");
        searchProject.mpid = "";
        onClear();
    }

    function clearConstructionStartDateSearch() {
        searchProject.constructionStartDate = null;
        onClear()
    }

    function clearConstructionEndDateSearch() {
        searchProject.constructionEndDate = null;
        onClear()
    }

    function clearInServiceStartDateSearch() {
        searchProject.inServiceStartDate = null;
        onClear()
    }

    function clearInServiceEndDateSearch() {
        searchProject.inServiceEndDate = null;
        onClear()
    }
    function clearCommisioningEndDateSearch() {
        searchProject.commisioningEndDate = null;
        onClear()
    }

    function clearCommisioningStartDateSearch() {
        searchProject.commisioningStartDate = null;
        onClear()
    }

    function clearExpectedCloseStartDateSearch() {
        searchProject.expectedCloseStartDate = null;
        onClear()
    }
    function  clearExpectedCloseEndDateSearch() {
        searchProject.expectedCloseEndDate = null;
        onClear()
    }

    function clearConstructionDateNull() {
        searchProject.constructionDateNull = false;
        onClear()
    }

    function clearInServiceDateNull() {
        searchProject.inServiceDateNull = false;
        onClear()
    }

    function clearCommisioningDateNull() {
        searchProject.commisioningDateNull = false;
        onClear()
    }

    function clearExpectedDateNull() {
        searchProject.expectedDateNull = false;
        onClear()
    }

    function setConstructionStartDate(date) {
        clearConstructionDateNull();
        searchProject.onChangeConstructionStartDate(date);
        setAdvancedFiltersToCookie();
    }

    function setConstructionEndtDate(date) {
        clearConstructionDateNull();
        searchProject.onChangeConstructionEndDate(date);
        setAdvancedFiltersToCookie();
    }

    function setCommisioningEndDate(date) {
        clearCommisioningDateNull();
        searchProject.onChangeCommisioningEndDate(date);
        setAdvancedFiltersToCookie();
    }

    function  setCommisioningStartDate(date) {
        clearCommisioningDateNull();
        searchProject.onChangeCommisioningStartDate(date);
        setAdvancedFiltersToCookie();
    }

    function setExpectedCloseStartDate(date) {
        clearExpectedDateNull();
        searchProject.onChangeExpectedCloseStartDate(date);
        setAdvancedFiltersToCookie();
    }

    function setExpectedCloseEndDate(date) {
        clearExpectedDateNull();
        searchProject.onChangeExpectedCloseEndDate(date);
        setAdvancedFiltersToCookie();
    }

    function setInServiceStartDate(date) {
        clearInServiceDateNull();
        searchProject.onChangeInServiceStartDate(date);
        setAdvancedFiltersToCookie();
    }

    function setInServiceEndDate(date) {
        clearInServiceDateNull();
        searchProject.onChangeInServiceEndDate(date);
        setAdvancedFiltersToCookie();
    }

    function setMyProjectsFlagChange(e) {
        setMyProjectsFlag(e.target.value);
        searchProject.setMyProjectsFlag(e.target.value);
        const selectedNewPreferencesArray = {
            selectedStatRegs: (searchProject && searchProject.selectedStationRegions) || [],
            selectedStatAreas: (searchProject && searchProject.selectedStationAreas) || [],
            selectedPCAreas: (searchProject && searchProject.selectedPCAreas) || [],
            selectedProjFlag: (searchProject && searchProject.myProjectsFlag) || '',
            selectedDefaultDashView: activeTabValueFromContext
        };
        Cookies.set('filters', selectedNewPreferencesArray);
    }

    function setNullConstructionDate(e) {
        if (e.target.checked) {
            clearConstructionEndDateSearch();
            clearConstructionStartDateSearch();
            onClear()
        }
        searchProject.setNullConstructionDate();
        setAdvancedFiltersToCookie();
    }

    function setNullInServiceDate(e) {
        if (e.target.checked) {
            clearInServiceEndDateSearch();
            clearInServiceStartDateSearch();
            onClear()
        }
        searchProject.setNullInServiceDate();
        setAdvancedFiltersToCookie();
    }

    function setNullCommisioningDate(e) {
        if (e.target.checked) {
            clearCommisioningEndDateSearch();
            clearCommisioningStartDateSearch();
            onClear()
        }
        searchProject.setNullCommisioningDate();
        setAdvancedFiltersToCookie();
    }

    function setNullExpectedDate(e) {
        if (e.target.checked) {
            clearExpectedCloseEndDateSearch();
            clearExpectedCloseStartDateSearch();
            onClear()
        }
        searchProject.setNullExpectedDate();
        setAdvancedFiltersToCookie();
    }

    function renderProject() {
        if (suggestions.length === 0 || text === "") {
            return null;
        }
        return (
            <List className='list-style'>
                {suggestions.map((suggestion, index) => (
                    <List.Item className='list-item' onClick={() => suggestionSelected(suggestion)}>
                        {suggestion}
                    </List.Item>
                ))}
            </List>
        );
    }

    function renderBpIdProject() {
        if (bpIdSuggestions.length === 0 || bpIdText === "") {
            return null;
        }
        return (
            <List className='list-style'>
                {bpIdSuggestions.map((bpIdSuggestion, index) => (
                    <List.Item className='list-item' onClick={() => bpIdSuggestionSelected(bpIdSuggestion)}>
                        {bpIdSuggestion.name}
                    </List.Item>
                ))}
            </List>
        );
    }

    function onBPIDTextChange(e) {
        let value = e.target.value;
        if (!value) {
            clearBPIdSearch();
        }
        let bpIdSuggests = [];
        if (value.length > 0) {
            value = value.replace(/[^\w\s]/gi, '');
            const regex = new RegExp(`^${value}`, "i");
            bpIdSuggests = bpIds
                .sort()
                .filter(bpId => regex.test(bpId.name));
        }
        setbpIdSuggestions(bpIdSuggests);
        setbpIdText(value);
    }

    async function bpIdSuggestionSelected(suggestion) {
        setbpIdText(suggestion.name);
        setbpIdSuggestions([]);
        searchProject.selectedBPID(suggestion.name)
        setAdvancedFiltersToCookie();
    }

    function renderWorkOrderProject() {
        if (workOrderSuggestions.length === 0 || workOrderText === "") {
            return null;
        }
        return (
            <List className='list-style'>
                {workOrderSuggestions.map((workOrderSuggestion, index) => (
                    <List.Item className='list-item' onClick={() => workOrderSuggestionSelected(workOrderSuggestion)}>
                        {workOrderSuggestion.name}
                    </List.Item>
                ))}
            </List>
        );
    }

    async function workOrderSuggestionSelected(workOrderSuggestion) {
        setWorkOrderText(workOrderSuggestion.name);
        setWorkOrderSuggestions([]);
        searchProject.selectedWorkOrder(workOrderSuggestion.name)
        setAdvancedFiltersToCookie();
    }

    function onWorkOrderTextChange(e) {
        let value = e.target.value;
        if (!value) {
            clearWorkOrderSearch();
        }
        let workOrderSuggests = [];
        if (value.length > 0) {
            value = value.replace(/[^\w\s]/gi, '');
            const regex = new RegExp(`^${value}`, "i");
            workOrderSuggests = workOrders
                .sort()
                .filter(bpId => regex.test(bpId.name));
        }
        setWorkOrderSuggestions(workOrderSuggests);
        setWorkOrderText(value);
    }

    function renderMpIdProject() {
        if (mpIdSuggestions.length === 0 || mpIdText === "") {
            return null;
        }
        return (
            <List className='list-style'>
                {mpIdSuggestions.map((mpIdSuggestion, index) => (
                    <List.Item className='list-item' onClick={() => mpIdSuggestionSelected(mpIdSuggestion)}>
                        {mpIdSuggestion.name}
                    </List.Item>
                ))}
            </List>
        );
    }

    async function mpIdSuggestionSelected(suggestion) {
        setmpIdText(suggestion.name);
        setmpIdSuggestions([]);
        searchProject.selectedMPID(suggestion.name)
        setAdvancedFiltersToCookie();
    }

    function onMPIDTextChange(e) {
        let value = e.target.value;
        if (!value) {
            clearMPIdSearch();
        }
        let mpIdSuggests = [];
        if (value.length > 0) {
            value = value.replace(/[^\w\s]/gi, '');
            const regex = new RegExp(`^${value}`, "i");
            mpIdSuggests = mpIds
                .sort()
                .filter(mpId => regex.test(mpId.name));
        }
        setmpIdSuggestions(mpIdSuggests);
        setmpIdText(value);
    }

    function onClearClick() {
        clearSearch();
    }

    function pushStatRegPrefsToCookie(selectedVals) {
        const selectedNewPreferencesArray = {
            selectedStatRegs: (searchProject && searchProject.selectedStationRegions) || [],
            selectedStatAreas: (searchProject && searchProject.selectedStationAreas) || [],
            selectedPCAreas: (searchProject && searchProject.selectedPCAreas) || [],
            selectedProjFlag: (searchProject && searchProject.myProjectsFlag) || '',
            selectedDefaultDashView: activeTabValueFromContext
        };
        Cookies.set('filters', selectedNewPreferencesArray);
    }


    function pushStatAreasPrefsToCookie(selectedVals) {
        const selectedNewPreferencesArray = {
            selectedStatRegs: (searchProject && searchProject.selectedStationRegions) || [],
            selectedStatAreas: (searchProject && searchProject.selectedStationAreas) || [],
            selectedPCAreas: (searchProject && searchProject.selectedPCAreas) || [],
            selectedProjFlag: (searchProject && searchProject.myProjectsFlag) || '',
            selectedDefaultDashView: activeTabValueFromContext
        };
        Cookies.set('filters', selectedNewPreferencesArray);
    }

    function pushPCAreasPrefsToCookie(selectedVals) {
        const selectedNewPreferencesArray = {
            selectedStatRegs: (searchProject && searchProject.selectedStationRegions) || [],
            selectedStatAreas: (searchProject && searchProject.selectedStationAreas) || [],
            selectedPCAreas: (searchProject && searchProject.selectedPCAreas) || [],
            selectedProjFlag: (searchProject && searchProject.myProjectsFlag) || '',
            selectedDefaultDashView: activeTabValueFromContext
        };
        Cookies.set('filters', selectedNewPreferencesArray);
    }



    // For clearing all section 
    const stationMultiselectRef = useRef();
    const stationAreasRef = useRef();
    const pcAreasRef  =  useRef()

    // for stationRegions rest function
    const resetSelectStationRegionsField = () => {
      
        stationMultiselectRef.current.resetSelectedValues();
        searchProject.setSelectedStationRegion([]) 
                                pushStatRegPrefsToCookie()
       
    };

    // for StationArea reset function

const resetSelectStationAreasField = () => {
      
        stationAreasRef.current.resetSelectedValues();
    searchProject.setSelectedStationAreas([])
    pushStatRegPrefsToCookie()
       
    };

    // for pcAreas reset function

const resetPcAreasField = () => {
      
        pcAreasRef.current.resetSelectedValues();
        searchProject.setSelectedPCAreas([])
    pushStatRegPrefsToCookie()
       
    };

    return (
        <div className='container-fluid'>
            <Row gutter={16}>
                <Col xs={8} md={8} lg={6} style={{ textAlign: 'center' }} id="dropdown-search">
                    {stationRegions && stationRegions.length > 0 &&
                        <h6>Station Region</h6>
                    }
                    {stationRegions && stationRegions.length > 0 &&
                        <MultiselectExtension options={stationRegions}
                            selectedValues={parsedUserSelectionsFrmCookie.selectedStatRegs && parsedUserSelectionsFrmCookie.selectedStatRegs.length > 0 ?
                                stationRegions.filter(t => parsedUserSelectionsFrmCookie.selectedStatRegs.includes(t.name)) : []}
                            onSelect={(selectedStatRegVals) => {
                                searchProject.setSelectedStationRegion(selectedStatRegVals)
                                pushStatRegPrefsToCookie()
                            }}
                            onRemove={(unselectedStatRegVals) => {
                                searchProject.setSelectedStationRegion(unselectedStatRegVals)
                                pushStatRegPrefsToCookie()
                            }}
                            showCheckbox={true}
                            displayValue="name"
                        placeholder={parsedUserSelectionsFrmCookie && parsedUserSelectionsFrmCookie.selectedStatRegs ? parsedUserSelectionsFrmCookie.selectedStatRegs.join(',') : 'Filter'}
                        ref={stationMultiselectRef}
                        resetSelectField={resetSelectStationRegionsField}

                        />
                    }
                </Col>
                <Col xs={7} md={7} lg={7} style={{ textAlign: 'center' }} id="dropdown-search">
                    {stationAreas && stationAreas.length > 0 &&
                        <h6>TFS Station Area</h6>
                    }
                    {stationAreas && stationAreas.length > 0 &&
                        <MultiselectExtension options={stationAreas}
                            selectedValues={parsedUserSelectionsFrmCookie.selectedStatAreas && parsedUserSelectionsFrmCookie.selectedStatAreas.length > 0 ?
                                stationAreas.filter(t => parsedUserSelectionsFrmCookie.selectedStatAreas.includes(t.name)) : []}
                            onSelect={(selectedStatAreaVals) => {
                                searchProject.setSelectedStationAreas(selectedStatAreaVals)
                                pushStatAreasPrefsToCookie()
                            }}
                            onRemove={(unselectedStatAreaVals) => {
                                searchProject.setSelectedStationAreas(unselectedStatAreaVals)
                                pushStatAreasPrefsToCookie()
                            }}
                            showCheckbox={true}
                            displayValue="name"
                        placeholder={parsedUserSelectionsFrmCookie && parsedUserSelectionsFrmCookie.selectedStatAreas ? parsedUserSelectionsFrmCookie.selectedStatAreas.join(",") : 'Filter'}
                        ref={stationAreasRef}
                        resetSelectField={resetSelectStationAreasField}
                        />
                    }
                </Col>
                <Col xs={7} md={7} lg={7} style={{ textAlign: 'center' }} id="dropdown-search">
                    {pcAreas && pcAreas.length > 0 &&
                        <h6>TFS P&C Area</h6>
                    }
                    {pcAreas && pcAreas.length > 0 &&
                        <MultiselectExtension options={pcAreas}
                            selectedValues={parsedUserSelectionsFrmCookie.selectedPCAreas && parsedUserSelectionsFrmCookie.selectedPCAreas.length > 0 ?
                                pcAreas.filter(t => parsedUserSelectionsFrmCookie.selectedPCAreas.includes(t.name)) : []}
                            onSelect={(selectedPCVals) => {
                                searchProject.setSelectedPCAreas(selectedPCVals)
                                pushPCAreasPrefsToCookie()
                            }}
                            onRemove={(unselectedPCVals) => {
                                searchProject.setSelectedPCAreas(unselectedPCVals) 
                                pushPCAreasPrefsToCookie()
                            }}

                            showCheckbox={true}
                            displayValue="name"
                        placeholder={parsedUserSelectionsFrmCookie && parsedUserSelectionsFrmCookie.selectedPCAreas ? parsedUserSelectionsFrmCookie.selectedPCAreas.join(',') : 'Filter'}
                        ref={pcAreasRef}
                        resetSelectField={resetPcAreasField}
                        />
                    }
                </Col>
                <Col xs={4} md={4} lg={4} style={{ textAlign: 'center' }} id="dropdown-search">
                    <h6>My Projects</h6>
                    <Form.Control as='select' id='myprojects-selector' value={isExternalContributorOrExternalView() ? 'Y' : myProjectsFlag}
                        style={{ height: '36px' }}
                        disabled={isExternalContributorOrExternalView()}
                        onChange={setMyProjectsFlagChange}
                    >
                        <option value={''}></option>
                        <option value={'Y'}>My Projects</option>
                        <option value={'N'}>Not My Projects</option>
                    </Form.Control>
                </Col>
            </Row>
            <Row style={{ textAlign: 'center', paddingTop: 24 }}>
                {!open === true &&
                    <Col xs={24} md={{ span: 12, offset: 6 }} id="project-search">
                        <Input
                            id="searchStation"
                            autoComplete="off"
                            onChange={onTextChanged}
                            
                            type="text"
                            value={text}
                            allowClear
                            style={{ paddingLeft: '16px', position: 'relative', }}
                            placeholder="Search Station Name"
                            prefix={<SearchOutlined id="search-icon"
                                style={{
                                    margin: '0px 4px', padding: 0,
                                    color: searchProject.stationName ? 'rgb(0, 150, 251)' : '',
                                    
                                }} />}
                        />
                        <span className="stationNameDropdown" >{renderProject()}</span>
                    </Col>
                }
                <Col xs={12} md={{ span: 6, offset: open ? 18 : 0 }} id="advanced-search">
                    <Button className="advanced-search-button"
                        onClick={() => toggleOpen(!open)}
                        aria-controls="example-collapse-text"
                        aria-expanded={open}
                    >
                        <span className="icon-button"> {!open === true ? (<PlusCircleOutlined />) : (<MinusCircleOutlined />)} </span>
                    </Button>
                    <span className="advanced-search-text">
                        Advanced Search
                        {((searchProject.stationName && searchProject.stationName.length > 0) ||
                            (searchProject.bpid && searchProject.bpid.length > 0) ||
                            (searchProject.workOrder && searchProject.workOrder.length > 0) ||
                            (searchProject.mpid && searchProject.mpid.length > 0)||
                            ((searchProject.constructionStartDate && searchProject.constructionStartDate.length > 0) &&
                                (searchProject.constructionEndDate && searchProject.constructionEndDate.length > 0)) ||
                            ((searchProject.inServiceStartDate && searchProject.inServiceStartDate.length > 0) &&
                                (searchProject.inServiceEndDate && searchProject.inServiceEndDate.length > 0))||
                                ((searchProject.commisioningStartDate && searchProject.commisioningStartDate.length > 0) &&
                                (searchProject.commisioningEndDate && searchProject.commisioningEndDate.length > 0)) ||
                            ((searchProject.expectedCloseStartDate && searchProject.expectedCloseStartDate.length > 0) &&
                                (searchProject.expectedCloseEndDate && searchProject.expectedCloseEndDate.length > 0)))||
                                (searchProject.constructionDateNull && searchProject.constructionDateNull > 0)|| 
                                (searchProject.inServiceDateNull && searchProject.inServiceDateNull > 0)||
                                (searchProject.commisioningDateNull && searchProject.commisioningDateNull > 0)||
                                (searchProject.expectedDateNull && searchProject.expectedDateNull > 0) ?
                            <span style={{ color: 'rgb(0, 150, 251)' }}> ON</span> :
                            <span> OFF</span>
                        }
                    </span>
                </Col>
            </Row>
            <div className='container-fluid'>
                <Row id="open-search">
                    <Collapse in={open}>
                        <div id="example-collapse-text">
                            <Row gutter={16}>
                                <Col xs={24} md={12} lg={6} style={{ textAlign: 'center' }} id="project-search">
                                    <h6>Station Name</h6>
                                    <Input
                                        className="input-text-control advanced-search-station"
                                        id="input-text-control-name-id"
                                        autoComplete="off"
                                        onChange={onTextChanged}
                                        type="text"
                                        value={text}
                                        allowClear
                                        placeholder="Search Station Name"
                                        prefix={<SearchOutlined id="search-icon" style={searchProject.stationName ? { color: 'rgb(0, 150, 251)' } : {}} />}
                                    />
                                    <span className="stationNameDropdown" >{renderProject()}</span>
                                </Col>
                                <Col xs={24} md={12} lg={6} style={{ textAlign: 'center' }} id="project-search">
                                    <h6>BPID</h6>
                                    <Input
                                        className="input-text-control"
                                        id="input-text-control-bpid"
                                        autoComplete="off"
                                        onChange={onBPIDTextChange}
                                        type="text"
                                        value={bpIdText}
                                        allowClear
                                        placeholder="Search BPID"
                                        prefix={<SearchOutlined id="search-icon" style={searchProject.stationName ? { color: 'rgb(0, 150, 251)' } : {}} />}
                                    />
                                    <span className="bpidDropdown" >{renderBpIdProject()}</span>
                                </Col>
                                <Col xs={24} md={12} lg={6} style={{ textAlign: 'center' }} id="project-search">
                                    <h6>Work Order</h6>
                                    <Input
                                        className="input-text-control"
                                        id="input-text-control-woid"
                                        autoComplete="off"
                                        onChange={onWorkOrderTextChange}
                                        type="text"
                                        value={workOrderText}
                                        allowClear
                                        placeholder="Search Work Order"
                                        prefix={<SearchOutlined id="search-icon" style={searchProject.stationName ? { color: 'rgb(0, 150, 251)' } : {}} />}
                                    />
                                    <span className="workOrderDropdown" >{renderWorkOrderProject()}</span>
                                </Col>
                                <Col xs={24} md={12} lg={6} style={{ textAlign: 'center' }} id="project-search">
                                    <h6>MPID</h6>
                                    <Input
                                        className="input-text-control"
                                        id="input-text-control-woid"
                                        autoComplete="off"
                                        onChange={onMPIDTextChange}
                                        type="text"
                                        value={mpIdText}
                                        allowClear
                                        placeholder="Search MPID"
                                        prefix={<SearchOutlined id="search-icon" style={searchProject.stationName ? { color: 'rgb(0, 150, 251)' } : {}} />}
                                    />
                                    <span className="mpidDropdown" >{renderMpIdProject()}</span>
                                </Col>
                            </Row>
                            <hr />
                            <Row>
                                <Col xs={24} md={12} lg={8} xl={6} style={{ textAlign: 'center' }}>
                                    <Row style={{ justifyContent: 'center' }}>
                                        <SearchOutlined style={{ color: searchProject.constructionStartDate && searchProject.constructionEndDate ? 'rgb(0, 150, 251)' : '', display: 'inline-block', verticalAlign: 'top' }} />
                                        <h6 style={{ display: "inline-block", verticalAlign: 'top', marginLeft: '10px' }}>Construction Start Date</h6>
                                    </Row>
                                    <Row style={{ alignItems: 'center' }}>
                                        <Col xs={8} style={{ textAlign: 'right', paddingRight: '10px' }}>
                                            <b>From Date:</b>
                                        </Col>
                                        <Col xs={14}>
                                            <DatePicker
                                                autoComplete="off"
                                                format={'MMMM DD, YYYY'}
                                                id="ConstructionStartDate"
                                                allowClear={false}
                                                defaultValue={moment()}
                                                value={searchProject.constructionStartDate ? moment(searchProject.constructionStartDate) : searchProject.constructionStartDate}
                                                onChange={setConstructionStartDate}
                                            />
                                        </Col>
                                        <Col xs={2} style={{ textAlign: 'left' }}>
                                            {searchProject.constructionStartDate &&
                                                <Button onClick={() => clearConstructionStartDateSearch()}
                                                    style={{ border: 'none', padding: 0, margin: 0 }}
                                                    icon={<CloseCircleFilled style={{ verticalAlign: 'baseline' }} />} />
                                            }
                                        </Col>
                                    </Row>
                                    <Row style={{ alignItems: 'center', marginTop: '2px'}}>
                                        <Col xs={8} style={{ textAlign: 'right', paddingRight: '10px' }}>
                                            <b>To Date:</b>
                                        </Col>
                                        <Col xs={14}>
                                            <DatePicker
                                                autoComplete="off"
                                                format={'MMMM DD, YYYY'}
                                                id="ConstructionEndDate"
                                                allowClear={false}
                                                defaultValue={moment()}
                                                value={searchProject.constructionEndDate ? moment(searchProject.constructionEndDate) : searchProject.constructionEndDate}
                                                onChange={setConstructionEndtDate}
                                            />
                                        </Col>
                                        <Col xs={2} style={{ textAlign: 'left' }}>
                                            {searchProject.constructionEndDate &&
                                                <Button onClick={() => clearConstructionEndDateSearch()}
                                                    style={{ border: 'none', padding: 0, margin: 0 }}
                                                    icon={<CloseCircleFilled style={{ verticalAlign: 'baseline' }} />} />
                                            }
                                        </Col>
                                    </Row>
                                    <Row style={{ justifyContent: 'center', padding: 10 }}>
                                        <Col>
                                            <Checkbox
                                                id="null_const_date_checkbox"
                                                checked={searchProject.constructionDateNull}
                                                onChange={setNullConstructionDate}
                                                style={{ display: 'flex', border: 'none', padding: 0, margin: 0 }}
                                            />
                                        </Col>
                                        <Col style={{ border: 'none', padding: 0, margin: 0 }}>
                                            <label style={{ border: 'none', paddingLeft: 10, margin: 0 }}>Null</label>
                                        </Col>
                                    </Row>
                                </Col>

                                <Col xs={24} md={12} lg={8} xl={6} style={{ textAlign: 'center' }}>
                                    <Row style={{ justifyContent: 'center' }}>
                                        <SearchOutlined style={{ color: searchProject.inServiceStartDate && searchProject.inServiceEndDate ? 'rgb(0, 150, 251)' : '', display: 'inline-block', verticalAlign: 'top' }} />
                                        <h6 style={{ display: "inline-block", verticalAlign: 'top', marginLeft: '10px' }}>In-Service Date</h6>
                                    </Row>
                                    <Row style={{ alignItems: 'center' }}>
                                        <Col xs={8}  style={{ textAlign: 'right', paddingRight: '10px' }} >
                                            <b>From Date:</b>
                                        </Col>
                                        <Col xs={14}>
                                            <DatePicker
                                                autoComplete="off"
                                                format={'MMMM DD, YYYY'}
                                                id="InServiceFromDate"
                                                allowClear={false}
                                                defaultValue={moment()}
                                                value={searchProject.inServiceStartDate ? moment(searchProject.inServiceStartDate) : searchProject.inServiceStartDate}
                                                onChange={setInServiceStartDate}
                                            />
                                        </Col>
                                        <Col xs={2} style={{ textAlign: 'left' }}>
                                            {searchProject.inServiceStartDate &&
                                                <Button onClick={() => clearInServiceStartDateSearch()}
                                                    style={{ border: 'none', padding: 0, margin: 0 }}
                                                    icon={<CloseCircleFilled style={{ verticalAlign: 'baseline' }} />} />
                                            }
                                        </Col>
                                    </Row>
                                    <Row style={{ alignItems: 'center', marginTop: '2px' }}>
                                        <Col xs={8}   style={{ textAlign: 'right',  paddingRight: '10px' }}>
                                            <b>To Date:</b>
                                        </Col>
                                        <Col xs={14}>
                                            <DatePicker
                                                autoComplete="off"
                                                format={'MMMM DD, YYYY'}
                                                id="InServiceToDate"
                                                allowClear={false}
                                                defaultValue={moment()}
                                                value={searchProject.inServiceEndDate ? moment(searchProject.inServiceEndDate) : searchProject.inServiceEndDate}
                                                onChange={setInServiceEndDate}
                                            />
                                        </Col>

                                        <Col xs={2} style={{ textAlign: 'left' }}>
                                            {searchProject.inServiceEndDate &&
                                                <Button onClick={() => clearInServiceEndDateSearch()}
                                                    style={{ border: 'none', padding: 0, margin: 0 }}
                                                    icon={<CloseCircleFilled style={{ verticalAlign: 'baseline' }} />} />
                                            }
                                        </Col>
                                    </Row>

                                    <Row style={{ justifyContent: 'center', padding: 10 }}>
                                        <Col>
                                            <Checkbox
                                                id="null_serv_date_checkbox"
                                                checked={searchProject.inServiceDateNull}
                                                onChange={setNullInServiceDate}
                                                style={{ display: 'flex', border: 'none', padding: 0, margin: 0 }}
                                            />
                                        </Col>
                                        <Col style={{ border: 'none', padding: 0, margin: 0 }}>
                                            <label style={{ border: 'none', paddingLeft: 10, margin: 0 }}>Null</label>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xs={24} md={12} lg={8} xl={6} style={{ textAlign: 'center' }} >
                                    <Row style={{ justifyContent: 'center' }}>
                                        <SearchOutlined style={{ color: searchProject.commisioningStartDate && searchProject.commisioningEndDate ? 'rgb(0, 150, 251)' : '', display: 'inline-block', verticalAlign: 'top' }} />
                                        <h6 style={{ display: "inline-block", verticalAlign: 'top', marginLeft: '10px' }}>Checklist Release Date</h6>
                                    </Row>
                                    <Row style={{ alignItems: 'center' }}>
                                        <Col xs={8}   style={{ textAlign: 'right', paddingRight: '10px' }}>
                                            <b>From Date:</b>
                                        </Col>
                                        <Col xs={14}>
                                            <DatePicker
                                                autoComplete="off"
                                                format={'MMMM DD, YYYY'}
                                                id="CommisioningFromDate"
                                                allowClear={false}
                                                defaultValue={moment()}
                                                value={searchProject.commisioningStartDate ? moment(searchProject.commisioningStartDate) : searchProject.commisioningStartDate}
                                                onChange={setCommisioningStartDate}
                                            />
                                        </Col>
                                        <Col xs={2} style={{ textAlign: 'left' }}>
                                            {searchProject.commisioningStartDate &&
                                                <Button onClick={() => clearCommisioningStartDateSearch()}
                                                    style={{ border: 'none', padding: 0, margin: 0 }}
                                                    icon={<CloseCircleFilled style={{ verticalAlign: 'baseline' }} />} />
                                            }
                                        </Col>
                                    </Row>
                                    <Row style={{ alignItems: 'center',  marginTop: '2px' }}>
                                        <Col xs={8}   style={{ textAlign: 'right',  paddingRight: '10px' }}>
                                            <b>To Date:</b>
                                        </Col>
                                        <Col xs={14}>
                                            <DatePicker
                                                autoComplete="off"
                                                format={'MMMM DD, YYYY'}
                                                id="CommisioningToDate"
                                                allowClear={false}
                                                defaultValue={moment()}
                                                value={searchProject.commisioningEndDate ? moment(searchProject.commisioningEndDate) : searchProject.commisioningEndDate}
                                                onChange={setCommisioningEndDate}
                                            />
                                        </Col>
                                        <Col xs={2} style={{ textAlign: 'left' }}>
                                            {searchProject.commisioningEndDate &&
                                                <Button onClick={() => clearCommisioningEndDateSearch()}
                                                    style={{ border: 'none', padding: 0, margin: 0 }}
                                                    icon={<CloseCircleFilled style={{ verticalAlign: 'baseline' }} />} />
                                            }
                                        </Col>
                                    </Row>
                                    <Row style={{ justifyContent: 'center', padding: 10 }}>
                                        <Col>
                                            <Checkbox
                                                id="null_check_date_checkbox"
                                                checked={searchProject.commisioningDateNull}
                                                onChange={setNullCommisioningDate}
                                                style={{ display: 'flex', border: 'none', padding: 0, margin: 0 }}
                                            />
                                        </Col>
                                        <Col style={{ border: 'none', padding: 0, margin: 0 }}>
                                            <label style={{ border: 'none', paddingLeft: 10, margin: 0 }}>Null</label>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xs={24} md={12} lg={8} xl={6} style={{ textAlign: 'center' }}>
                                    <Row style={{ justifyContent: 'center' }}>
                                        <SearchOutlined style={{ color: searchProject.expectedCloseStartDate && searchProject.expectedCloseEndDate ? 'rgb(0, 150, 251)' : '', display: 'inline-block', verticalAlign: 'top' }} />
                                        <h6 style={{ display: "inline-block", verticalAlign: 'top', marginLeft: '10px' }}>Expected Close Date</h6>
                                    </Row>
                                    <Row style={{ alignItems: 'center' }}>
                                        <Col xs={8} style={{ textAlign: 'right', paddingRight: '10px' }}>
                                            <b>From Date:</b>
                                        </Col>
                                        <Col xs={14}>
                                            <DatePicker
                                                autoComplete="off"
                                                format={'MMMM DD, YYYY'}
                                                id="ExpectedCloseFromDate"
                                                allowClear={false}
                                                defaultValue={moment()}
                                                value={searchProject.expectedCloseStartDate ? moment(searchProject.expectedCloseStartDate) : searchProject.expectedCloseStartDate}
                                                onChange={setExpectedCloseStartDate}
                                            />
                                        </Col>
                                        <Col xs={2} style={{ textAlign: 'left' }}>
                                            {searchProject.expectedCloseStartDate &&
                                                <Button onClick={() => clearExpectedCloseStartDateSearch()}
                                                    style={{ border: 'none', padding: 0, margin: 0 }}
                                                    icon={<CloseCircleFilled style={{ verticalAlign: 'baseline' }} />} />
                                            }
                                        </Col>
                                    </Row>
                                    <Row style={{ alignItems: 'center',  marginTop: '2px' }}>
                                        <Col xs={8}   style={{ textAlign: 'right', paddingRight: '10px' }}>
                                            <b>To Date:</b>
                                        </Col>
                                        <Col xs={14}>
                                            <DatePicker
                                                autoComplete="off"
                                                format={'MMMM DD, YYYY'}
                                                id="ExpectedCloseToDate"
                                                allowClear={false}
                                                defaultValue={moment()}
                                                value={searchProject.expectedCloseEndDate ? moment(searchProject.expectedCloseEndDate) : searchProject.expectedCloseEndDate}
                                                onChange={setExpectedCloseEndDate}
                                            />
                                        </Col>

                                        <Col xs={2} style={{ textAlign: 'left' }}>
                                            {searchProject.expectedCloseEndDate &&
                                                <Button onClick={() =>  clearExpectedCloseEndDateSearch()}
                                                    style={{ border: 'none', padding: 0, margin: 0 }}
                                                    icon={<CloseCircleFilled style={{ verticalAlign: 'baseline' }} />} />
                                            }
                                        </Col>
                                    </Row>

                                    <Row style={{ justifyContent: 'center', padding: 10 }}>
                                        <Col>
                                            <Checkbox
                                                id="null_expect_date_checkbox"
                                                checked={searchProject.expectedDateNull}
                                                onChange={setNullExpectedDate}
                                                style={{ display: 'flex', border: 'none', padding: 0, margin: 0 }}
                                            />
                                        </Col>
                                        <Col style={{ border: 'none', padding: 0, margin: 0 }}>
                                            <label style={{ border: 'none', paddingLeft: 10, margin: 0 }}>Null</label>
                                        </Col>
                                    </Row>

                                </Col>
                            </Row>
                            <hr />
                            <Row className="search-clear-buttons">
                                <Button
                                    className="btn-clear"
                                    onClick={() => onClearClick()}
                                > Clear All </Button>
                            </Row>
                        </div>

                    </Collapse>
                </Row>
            </div>
        </div>

    );

});
